import React, { useState,useEffect } from 'react';
import axios from 'axios';
import { TextField, Checkbox, FormControlLabel, Button, Grid, Typography, Paper,IconButton,InputLabel,Select,MenuItem ,FormGroup} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useAuth from './useAuth.js';
import { useNotification } from "../../components/NotificationContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
const MAX_IMAGE_SIZE = 10 * 1024 * 1024;
const IMAGE_ACCEPT = "image/jpeg,image/png,image/webp,image/heic,image/heif,image/avif,.jpg,.jpeg,.png,.webp,.heic,.heif,.avif";
const isAllowedImage = (file) => {
  const name = file.name.toLowerCase();
  return file.size <= MAX_IMAGE_SIZE && (
    file.type.startsWith("image/") ||
    [".heic", ".heif", ".avif"].some((ext) => name.endsWith(ext))
  );
};
const ProductAdd = () => {
  useAuth();
  const [productData, setProductData] = useState({
    description: '',
    name: '',
    price: '',
    category:'',
    in_stock: false,
    sort: "",
    colors: [],
    sizes: [], 
    colorStock: {},
    sizeStock: {},
    showColors: false,
    showSizes: false,
  });

  const [image, setImage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState('');
  const [multipleImages, setMultipleImages] = useState([]);
  const [multipleImagePreviews, setMultipleImagePreviews] = useState([]);
  const [categories, setCategories] = useState([]);
const [subCategories, setSubCategories] = useState([]);
const [selectedMainCategory, setSelectedMainCategory] = useState('');
const [selectedSubCategory, setSelectedSubCategory] = useState('');
  const showNotification = useNotification();
  const navigate = useNavigate();
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/categories`);
        setCategories(res.data);
      } catch (error) {
        console.error("Kategori verileri alınamadı:", error);
      }
    };
    fetchCategories();
  }, []);
  const handleMainCategoryChange = (e) => {
    const selectedId = e.target.value;
    setSelectedMainCategory(selectedId);
  
    const selectedCategory = categories.find(cat => cat.id === selectedId);
    setSubCategories(selectedCategory?.subCategories || []);
    setSelectedSubCategory('');
  };
  const handleSubCategoryChange = (e) => {
    setSelectedSubCategory(e.target.value);
    setProductData(prev => ({
      ...prev,
      category: e.target.value,
    }));
  };
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setProductData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };
  const handleShowColorsChange = (event) => {
    const { checked } = event.target;
    setProductData((prevData) => ({
      ...prevData,
      showColors: checked,  // Renklerin görünürlüğünü güncelle
    }));
  };
  
  const handleShowSizesChange = (event) => {
    const { checked } = event.target;
    setProductData((prevData) => ({
      ...prevData,
      showSizes: checked,  // Bedenlerin görünürlüğünü güncelle
    }));
  };
  const handleColorChange = (event) => {
    const { name, checked } = event.target;
    setProductData((prevData) => ({
      ...prevData,
      colors: checked 
        ? [...prevData.colors, name]  // Yeni renk ekleyin
        : prevData.colors.filter((color) => color !== name), // Renk çıkarın
    }));
  };
  
  const handleSizeChange = (event) => {
    const { name, checked } = event.target;
    setProductData((prevData) => ({
      ...prevData,
      sizes: checked 
        ? [...prevData.sizes, name]  // Yeni beden ekleyin
        : prevData.sizes.filter((size) => size !== name), // Beden çıkarın
    }));
  };
  const handleColorStockChange = (event) => {
    const { name, checked } = event.target;
    setProductData(prevState => ({
      ...prevState,
      colorStock: {
        ...prevState.colorStock,
        [name]: checked,
      }
    }));
  };
  
  const handleSizeStockChange = (event) => {
    const { name, checked } = event.target;
    setProductData(prevState => ({
      ...prevState,
      sizeStock: {
        ...prevState.sizeStock,
        [name]: checked,
      }
    }));
  };
  const handleCheckboxChange = () => {
    setProductData((prevData) => ({
      ...prevData,
      in_stock: !prevData.in_stock,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!isAllowedImage(file)) {
        showNotification('Gorsel 10 MB altinda ve desteklenen formatta olmali!', 'error');
        e.target.value = '';
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setImage(file); 
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    if (!image) {
      return;
    }
  
    setLoading(true);
    const token = localStorage.getItem('token');
  
    const formData = new FormData();
    // Ürün verileri
    formData.append('name', productData.name);
    formData.append('description', productData.description);
    formData.append('price', productData.price);
    formData.append('in_stock', productData.in_stock);
    formData.append('category', productData.category);
    formData.append('sort', productData.sort);
    multipleImages.forEach((file) => {
      formData.append('images', file); // backend'de "images" olarak karşıla
    });
    if (image) {
      formData.append('photo_url', image);
    }
   // Renkler ve renk stok durumu
   formData.append('colors', JSON.stringify(productData.colors)); // ['Kırmızı', 'Mavi']
   formData.append('colorStock', JSON.stringify(productData.colorStock)); // { Kırmızı: true, Mavi: false }
   formData.append('showColors', productData.showColors);
   // Bedenler ve beden stok durumu
   formData.append('sizes', JSON.stringify(productData.sizes)); // ['S', 'M']
   formData.append('sizeStock', JSON.stringify(productData.sizeStock)); // { S: true, M: false }
   formData.append('showSizes', productData.showSizes);
  
    try {
      await axios.post(
        `${process.env.REACT_APP_API_URL}/product`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );
  
      showNotification('Ürün Kayıtı Başarılı!', 'success');
      localStorage.setItem('notificationMessage', 'Ürün Kayıtı Başarılı!');
      localStorage.setItem('notificationSeverity', 'success');
      setLoading(false);
  
      setTimeout(() => {
        navigate('/admin');
      });
    } catch (error) {
      showNotification('Ürün Kayıtı Başarısız!', 'error');
      setLoading(false);
    }
  };
  const handleMultipleFileChange = (e) => {
    const files = Array.from(e.target.files).filter((file) => {
      const allowed = isAllowedImage(file);
      if (!allowed) {
        showNotification('Desteklenmeyen veya 10 MB ustu gorsel atlandi!', 'error');
      }
      return allowed;
    });
  
    const updatedImages = [...multipleImages, ...files];
    const updatedPreviews = [...multipleImagePreviews];
  
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        updatedPreviews.push({ file, preview: reader.result });
        setMultipleImagePreviews([...updatedPreviews]);
      };
      reader.readAsDataURL(file);
    });
  
    setMultipleImages(updatedImages);
  };
  const handleRemoveMultipleImage = (index) => {
    const updatedFiles = [...multipleImages];
    const updatedPreviews = [...multipleImagePreviews];
  
    updatedFiles.splice(index, 1);
    updatedPreviews.splice(index, 1);
  
    setMultipleImages(updatedFiles);
    setMultipleImagePreviews(updatedPreviews);
  };
    
  const handleBackClick = () => {
    navigate(-1);
  };
  return (
    <Grid container justifyContent="center" alignItems="center" sx={{ px: { xs: 1.5, sm: 3 }, py: { xs: 2, md: 4 } }}>
      <Grid size={{ xs: 12, sm: 10,md:10 }}>
        <Paper elevation={3} sx={{ p: { xs: 2, sm: 3 }, borderRadius: 1, backgroundColor: '#ffffff' }}>
        <IconButton onClick={handleBackClick} style={{ marginRight: '10px' }}>
        <ArrowBackIcon />
      </IconButton>
          <Typography variant="h4" gutterBottom align="center" style={{ fontWeight: 600, color: '#3f51b5' }}>
            Yeni ürün ekle
          </Typography>
          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Ürün ismi"
              name="name"
              value={productData.name}
              onChange={handleChange}
              margin="normal"
              variant="outlined"
              style={{ marginBottom: '15px' }}
            />
<TextField
  fullWidth
  label="Açıklama"
  name="description"
  value={productData.description}
  onChange={handleChange}
  multiline
  minRows={4}
  maxRows={6}
  variant="outlined"
  style={{
    marginBottom: '15px',
    borderRadius: '4px',
    fontSize: '16px',
  }}
/>
            <TextField
              fullWidth
              label="Ücret"
              name="price"
              value={productData.price}
              onChange={handleChange}
              margin="normal"
              variant="outlined"
              style={{ marginBottom: '15px' }}
            />

<InputLabel id="main-category-label">Ana Kategori</InputLabel>
<Select
  fullWidth
  labelId="main-category-label"
  value={selectedMainCategory}
  onChange={handleMainCategoryChange}
>
  {categories.map((cat) => (
    <MenuItem key={cat.id} value={cat.id}>
      {cat.name}
    </MenuItem>
  ))}
</Select>

{selectedMainCategory && subCategories.length > 0 && (
  <>
    <InputLabel id="sub-category-label" style={{ marginTop: '20px' }}>Alt Kategori</InputLabel>
    <Select
      fullWidth
      labelId="sub-category-label"
      value={selectedSubCategory}
      onChange={handleSubCategoryChange}
    >
      {subCategories.map((sub) => (
        <MenuItem key={sub.id} value={sub.id}>
          {sub.name}
        </MenuItem>
      ))}
    </Select>
  </>
)}

        <TextField
              fullWidth
              label="Ürün Sırası"
              name="sort"
              value={productData.sort}
              onChange={handleChange}
              margin="normal"
              variant="outlined"
              style={{ marginBottom: '15px' }}
            />
<FormControlLabel
  control={
    <Checkbox
      checked={productData.in_stock}
      onChange={handleCheckboxChange}
      color="primary"
    />
  }
  label="Stokta var mı"
  style={{ marginBottom: '10px' }}
/>

{/* Renk Stoğu */}
{productData.in_stock && (
  <FormControlLabel
    control={
      <Checkbox
        checked={productData.showColors} // Eğer renkler gösterilsin isteniyorsa true olmalı
        onChange={handleShowColorsChange} // Renklerin görünürlüğünü değiştiren fonksiyon
        color="primary"
      />
    }
    label="Renk Stoğu"
    style={{ marginBottom: '10px' }}
  />
)}


{productData.showColors && productData.in_stock && (
 <>
 <Typography variant="h6" style={{ marginBottom: '10px' }}>Renk</Typography>
 <FormGroup style={{ marginBottom: '20px' }}>
   {['Kırmızı', 'Mavi', 'Yeşil', 'Sarı', 'Beyaz', 'Siyah', 'Turuncu', 'Pembe', 'Mor', 'Gri', 'Kahverengi'].map((color) => (
     <div key={color}>
       {/* Renk seçimi */}
       <FormControlLabel
         control={
           <Checkbox
             checked={productData.colors.includes(color)}
             onChange={handleColorChange}
             name={color}
             color="primary"
           />
         }
         label={color}
       />

       {/* Eğer renk seçiliyse, stok durumu göster */}
       {productData.colors.includes(color) && (
         <FormControlLabel
           control={
             <Checkbox
               checked={productData.colorStock?.[color] || false}
               onChange={handleColorStockChange}
               name={color}
               color="primary"
             />
           }
           label={`Stokta var mı (${color})`}
           style={{ marginLeft: "30px" }}
         />
       )}
     </div>
   ))}
 </FormGroup>
</>

)}

{/* Beden seçenekleri */}
{productData.in_stock && (
  <FormControlLabel
    control={
      <Checkbox
        checked={productData.showSizes} // Eğer bedenler gösterilsin isteniyorsa true olmalı
        onChange={handleShowSizesChange} // Bedenlerin görünürlüğünü değiştiren fonksiyon
        color="primary"
      />
    }
    label="Beden Stoğu"
    style={{ marginBottom: '10px' }}
  />
)}

{productData.showSizes && productData.in_stock && (
 <>
 <Typography variant="h6" style={{ marginBottom: '10px' }}>Beden</Typography>
 <FormGroup style={{ marginBottom: '20px' }}>
   {['XS', 'S', 'M', 'L', 'XL'].map((size) => (
     <div key={size}>
       {/* Beden seçimi */}
       <FormControlLabel
         control={
           <Checkbox
             checked={productData.sizes.includes(size)}
             onChange={handleSizeChange}
             name={size}
             color="primary"
           />
         }
         label={size}
       />

       {/* Sadece seçili bedenler için stok durumu göster */}
       {productData.sizes.includes(size) && (
         <FormControlLabel
           control={
             <Checkbox
               checked={productData.sizeStock?.[size] || false}
               onChange={handleSizeStockChange}
               name={size}
               color="primary"
             />
           }
           label={`Stokta var mı (${size})`}
           style={{ marginLeft: "30px" }}
         />
       )}
     </div>
   ))}
 </FormGroup>
</>

)}


            <div style={{ marginBottom: '20px' }}>
              <input
                type="file"
                accept={IMAGE_ACCEPT}
                onChange={handleFileChange}
                style={{ display: 'none' }}
                id="upload-image"
              />
              <label htmlFor="upload-image">
                <Button variant="contained" color="secondary" component="span">
                 Ana Fotoğraf Yükle
                </Button>
              </label>
              <div style={{ marginTop: '10px', backgroundColor: 'grey', padding: '10px', borderRadius: '8px', boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)' }}>
  <Typography variant="h5" style={{ fontWeight: 'bold', color: '#fff', textAlign: "center" }}>
    Seçtiğiniz Fotoğraf
  </Typography>
  <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
    {imagePreview ? (
      <img
        src={imagePreview}
        alt="Preview"
        style={{
          maxWidth: '100%',
          maxHeight: '300px',
          objectFit: 'contain',
          borderRadius: '8px',
          border: '2px solid gold',
          boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
        }}
      />
    ) : (
<Typography
  variant="body2"
  style={{
    color: '#fff',
    textAlign: 'center',
    fontStyle: 'italic',
    height: '300px',
    width: '200px',
    border: '2px solid gold',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  }}
>
  Fotoğraf seçilmedi.
</Typography>
    )}
  </div>
</div>

            </div>
            <div style={{ marginBottom: '20px' }}>
  <input
    type="file"
    accept={IMAGE_ACCEPT}
    multiple
    onChange={handleMultipleFileChange}
    style={{ display: 'none' }}
    id="upload-multiple-images"
  />
  <label htmlFor="upload-multiple-images">
    <Button variant="contained" color="secondary" component="span" style={{ marginRight: "10px" }}>
      Çoklu Fotoğraf Yükle
    </Button>
  </label>
  <Typography variant="h6" style={{ marginTop: '10px', fontWeight: 500 }}>Seçilen Fotoğraflar</Typography>
  <Grid container spacing={2} style={{ marginTop: '10px' }}>
    {multipleImagePreviews.map((img, index) => (
      <Grid  key={index}>
        <div style={{ position: 'relative' }}>
          <img
            src={img.preview}
            alt={`Preview ${index}`}
            style={{
              width: '100px',
              height: '100px',
              objectFit: 'cover',
              borderRadius: '8px',
              border: '2px solid gold',
              boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
            }}
          />
          <Button
            size="small"
            onClick={() => handleRemoveMultipleImage(index)}
            style={{
              position: 'absolute',
              top: 0,
              right: 0,
              minWidth: '30px',
              padding: '0px',
              backgroundColor: 'rgba(255,0,0,0.8)',
              color: '#fff',
              borderRadius: '50%',
              fontWeight: 'bold'
            }}
          >
            X
          </Button>
        </div>
      </Grid>
    ))}
  </Grid>
</div>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              disabled={loading}
              style={{
                marginTop: '20px',
                padding: '12px',
                fontWeight: 600,
                transition: 'background-color 0.3s',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#303f9f')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#3f51b5')}
            >
              {loading ? "Kayıt Yapılıyor..." : "Ürünü Ekle"}
            </Button>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
};

export default ProductAdd;
